import type { ComponentType } from 'react';
import type { WidgetPage, WidgetPageType } from '../../types';
import { Main } from './main';
import { Settings } from './settings';

export const pages: Record<WidgetPageType, ComponentType<WidgetPage>> = {
  main: Main,
  settings: Settings
};
